import type { InferGetServerSidePropsType, GetServerSideProps } from "next";
import type { FC } from "react";
import { XpaLayout } from "@/components/xpa-layout/XpaLayout";
import styles from "@/styles/pages/Matches.module.scss";
import { ScrollToTopButton } from "@/components/scroll-to-top-button/ScrollToTopButton";
import { XpaSupportedComponentsResolver } from "./index";
import type { Layout } from "@motain/xpa-proto-files-web/lib/runtime/xpa";
import { fetchXpaLayoutWithResponseInfo } from "@/utils/fetchXpaLayout";
import {
  StreamName,
  useRegisterStream,
  useRegisterXpaStream,
} from "@/modules/analytics";

const CONTAINER_COUNT_LIMIT = 5;

const Yesterday: FC<InferGetServerSidePropsType<typeof getServerSideProps>> = (
  props,
) => {
  useRegisterStream(StreamName.MatchesStream);
  useRegisterXpaStream(props);

  return (
    <div className={styles.xpaContainer}>
      <XpaLayout
        layout={props}
        XpaSupportedComponentsResolver={XpaSupportedComponentsResolver}
        containersCountLimit={CONTAINER_COUNT_LIMIT}
      />
      <ScrollToTopButton className={styles.scrollToTopButton} />
    </div>
  );
};

export default Yesterday;

export const getServerSideProps: GetServerSideProps<Layout> = async (ctx) => {
  const layoutResponse = await fetchXpaLayoutWithResponseInfo(ctx);

  if (layoutResponse.status === 404) {
    return { notFound: true };
  } else {
    return { props: layoutResponse.layout };
  }
};
